export const CHECKS_SUMMARY_REPORT_FETCHING = 'CHECKS_SUMMARY_REPORT_FETCHING';
export const CHECKS_SUMMARY_REPORT_FETCH_ERROR =
  'CHECKS_SUMMARY_REPORT_FETCH_ERROR';
export const CHECKS_SUMMARY_REPORT_GET_REPORT =
  'CHECKS_SUMMARY_REPORT_GET_REPORT';



// WEBPACK FOOTER //
// ./src/pages/checkssummaryreport/state/checkssummaryreport/types.js